import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { CurrentUser } from '../models/currentuser.models';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })

/**
 * Dialogflow-service Component
 */
export class DialogflowService {
  currentuser!: CurrentUser;

  constructor(private http: HttpClient, private tokenService: TokenStorageService) {
    this.currentuser = this.tokenService.getCurrentUser();
  }

  /**
   * GET PESTAMP RECORD API
   * fetch record on basis of record guid
   */
    fetchDialogflowResponse(postdata: any): Observable<any> {
        console.log("sending message data");
        return this.http.post<any>(BASE_URL + 'bot', postdata)
    }
}